var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG08(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.947,
    viewBox: "0 0 80.945 80.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "#a31a42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.984,19.4c0,.987-.361,1.685-1.348,1.685-.964,0-1.324-.7-1.324-1.685V16.752c0-.987.36-1.685,1.324-1.685.987,0,1.348.7,1.348,1.685Zm-2.576-9.026c0-.989.338-1.566,1.228-1.566.914,0,1.252.577,1.252,1.566V11.48c0,.987-.338,1.566-1.252,1.566-.89,0-1.228-.579-1.228-1.566Zm5.32,8.737V17.329A3.234,3.234,0,0,0,13.9,14.055a2.871,2.871,0,0,0,1.588-2.839v-.675c0-2.552-1.323-3.924-3.851-3.924-2.5,0-3.8,1.372-3.8,3.924v.675a2.9,2.9,0,0,0,1.541,2.839,3.218,3.218,0,0,0-1.806,3.274v1.782c0,2.479,1.18,4.213,4.069,4.213,2.912,0,4.092-1.734,4.092-4.213",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.831,39.824,47.6,47.651a1.36,1.36,0,0,0-.47,1.175V70.761a.47.47,0,0,0,.47.469h8.5a.469.469,0,0,0,.468-.469V40.022c0-.259-.2-.732-.739-.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.129,50.021,23.9,57.847a1.362,1.362,0,0,0-.47,1.174V70.762a.47.47,0,0,0,.47.467h8.5a.468.468,0,0,0,.468-.467V50.218c0-.26-.2-.733-.739-.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.571,30.333a.232.232,0,0,0-.07-.178.242.242,0,0,0-.152-.067l-.045,0-.068,0-6.3,1.421-.115.012a.237.237,0,0,0-.123.4l.072.071,1.438,1.438L39.934,47.716l-6.593-6.594a.188.188,0,0,0-.268,0l-1.789,1.79,0,0L20.713,53.481a.191.191,0,0,0,0,.268L22.5,55.54a.187.187,0,0,0,.266,0L33.208,45.1l4.785,4.785a.1.1,0,0,0,.015.022L39.8,51.7a.188.188,0,0,0,.268,0l16.2-16.2,1.511,1.51a.237.237,0,0,0,.4-.156v-.02L59.568,30.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.027,51.394l-3.981,4.014a.19.19,0,0,1-.256-.01l-3.607-3.676c-.66-.658-.8-.125-.8.134v18.9a.466.466,0,0,0,.465.468h8.5a.469.469,0,0,0,.468-.468V51.542c0-.258-.2-.733-.788-.148",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.336,12.482c.458,0,.634-.273.634-.673V8.346a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.419,1.775-1.61,1.775H21.755V6.775h1.717c1.191,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.785,6.776h2.654v.907H26.9V9.576H28v.9H26.9v2.01h1.542v.907H25.785Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,11.682v-3.2A1.56,1.56,0,0,1,30.664,6.7c1.229,0,1.57.683,1.57,1.658v.781H31.22V8.268c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648A1.564,1.564,0,0,1,29,11.682",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.909,6.776h2.654v.907H34.021V9.576h1.1v.9h-1.1v2.01h1.542v.907H32.909Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.163,9.234V13.39h-.937V6.776h1.093l1.2,3.794V6.776h.927V13.39H38.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.022,6.776h2.956v.907h-.917V13.39H40.939V7.683h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.058,9.3l-.624,4.087H45.39L44.5,6.775h1.073l.517,4.195h.01l.556-4.195h.907l.615,4.195h.01L48.7,6.775h.936l-.858,6.614H47.721L47.068,9.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.337,11.858V8.307c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.264,7.683V9.741h.371a.481.481,0,0,0,.546-.546V8.22c0-.361-.165-.537-.546-.537Zm0,2.673V13.39H54.152V6.776h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3.005H56.308Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.09,10.171V13.39H57.978V6.776H59.09V9.683L60.3,6.776h1.092L60.1,9.751l1.317,3.639H60.251Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.369,11.293h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614h1.268L66.75,13.39H65.608L65.4,12.18h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.057,9.234V13.39H67.12V6.776h1.093l1.2,3.794V6.776h.927V13.39h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.654,12.482c.458,0,.634-.273.634-.673V8.346a.579.579,0,0,0-.634-.663h-.469v4.8ZM74.4,8.551v3.063c0,1.015-.419,1.775-1.61,1.775H71.073V6.775H72.79c1.191,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.755,16.492h2.654V17.4H22.867v1.893h1.1v.9h-1.1V22.2h1.542v.907H21.755Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,21.4V18.2a1.56,1.56,0,0,1,1.659-1.785c1.229,0,1.57.683,1.57,1.659v.78H27.112v-.868c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648A1.564,1.564,0,0,1,24.9,21.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.986,21.575V18.024c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M28.732,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.67,18.951v4.156h-.937V16.493h1.093l1.2,3.794V16.493h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.841,21.575V18.024c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M36.587,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.652,18.814h-.029l-.751,4.292h-.517l-.83-4.292h-.019v4.292h-.917V16.492h1.3l.722,3.727h.01l.644-3.727h1.405v6.614H43.652Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(45.301 16.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.038,21.4V18.2A1.56,1.56,0,0,1,48.7,16.414c1.229,0,1.57.683,1.57,1.659v.78H49.253v-.868c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648A1.564,1.564,0,0,1,47.038,21.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.84,19.575h1.58v3.531h-.8v-.722a1,1,0,0,1-1.064.8c-.956,0-1.4-.76-1.4-1.785V18.2a1.568,1.568,0,0,1,1.668-1.785c1.23,0,1.591.683,1.591,1.659v.585H54.4v-.673c0-.41-.155-.644-.556-.644s-.576.283-.576.683v3.551c0,.4.166.683.547.683.361,0,.546-.2.546-.634V20.453H53.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.167,17.4v2.058h.371a.481.481,0,0,0,.546-.546v-.975c0-.361-.165-.537-.546-.537Zm0,2.673v3.034H56.055V16.492h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3.005H58.211Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.968,21.575V18.024c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M59.714,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.929,19.019l-.624,4.087H64.261l-.888-6.614h1.073l.517,4.195h.01l.556-4.195h.907l.615,4.195h.01l.507-4.195H68.5l-.858,6.614H66.592l-.653-4.087Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.848,16.492H71.8V17.4h-.917v5.707H69.765V17.4h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.331,20.19H73.258v2.917H72.146V16.493h1.112v2.8h1.073v-2.8h1.122v6.614H74.331Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG08);
export default __webpack_public_path__ + "static/media/G08.d308ba01b5f6304e66ac7b89a818692f.svg";
export { ForwardRef as ReactComponent };